<app-loadconfirm *ngIf="showFormModalLoader" [modalloader]="true" [text]="'projecttask.loadconfirmform' | trans"
  [icon]="'pending'"></app-loadconfirm>

<div #taskcomponent cdkDragLockAxis="y" class="pb-0 mt-2 opacity taskcompcontainerclass"
  [matTooltip]="myTask ? 'My task - '+task.title : isCustomerTask ? 'Customer task - '+task.title : 'Vendor task - '+task.title">
  <app-filelist class="d-none" [projectId]="task.projectId" [list]="false" [fileToAdd]="fileToAdd"
    (numberOfFiles)="setNumberOfFiles($event)" [filetype]="'task'" [entityid]="task.taskId"
    [reloadTrigger]="filelistReloadTrigger"></app-filelist>
  <div class="p-0 rounded" cdkDrag cdkDragPreview [cdkDragDisabled]="!orgEdit || userview">
    <div *ngIf="userview" (click)="toggleCollapseArrow()" [ngClass]="{'done': task.taskstate == 'Done', 
    'open': task.taskstate != 'Done',
    'customer-task': isCustomerTask && !userview , 
    'vendor-task': !isCustomerTask && !userview,
    'my-task': myTask && !userview,
    'overdue-task': taskStatus == 'overdue' && userview,
    'due-task': taskStatus == 'midt' && userview,
    'upcoming-task': taskStatus == 'onTrack' && userview,
    'round-tops': task.show  }" class="row ml-0 mr-0 h-40">
      <div class="col col-md-3 col-lg-3">
        <p class="lh-40 text-truncate mb-0 align-middle font-weight-bold cursor-pointer text-light">{{task.title}}</p>
      </div>
      <div class="col-5 col-md-3 col-lg-3">
        <h6 class="text-light mb-0 lh-40 align-middle cursor-pointer text-truncate font-weight-light">
          {{ 'projecttask.project' | trans }}{{task.projectname}}
        </h6>
      </div>
      <div class="col-2 d-none d-lg-block">
        <h6 class="h-40 pt-0 text-light align-middle text-truncate font-weight-light lh-40 ">{{ 'projecttask.duration' |
          trans }}{{task.startdate}} - {{task.duedate}}</h6>
      </div>
      <div class="col-md-3 col-lg-2 d-none d-md-block">
        <h6 class="h-40 pt-0 text-light align-middle text-truncate lh-40 float-right">{{ 'projecttask.customer' | trans
          }}{{task.customername}}</h6>
      </div>
      <div class="col col-md-2 col-lg-2">
        <ng-container>
          <span [ngClass]="{'visible': task.taskstate == 'Done', 'd-none': task.taskstate != 'Done'}"
            matTooltip="{{ 'projecttask.taskisdone' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"
            class="material-icons align-middle lh-40 f-18 rounded-circle transistion cursor-pointer opacity text-white cursor-pointer mr-1 ml-1 float-right">
            done
          </span>
        </ng-container>
        <ng-container *ngIf="numberOfFiles && numberOfFiles > 0">
          <span matTooltip="{{ 'projecttask.attachtip' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"
            class="material-icons align-middle lh-40 f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1 float-right">
            attach_file
          </span>
        </ng-container>
        <ng-container *ngIf="numberOfComments > 0"
          matTooltip="{{numberOfComments}}{{ 'projecttask.commentsrelated' | trans }}" matTooltipPosition="above"
          matTooltipShowDelay="500">
          <span (click)="setTaskFilter(task)"
            matTooltip="{{numberOfComments}}{{ 'projecttask.commentsrelated' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500" class=" h-40 rounded cursor-pointer transistion float-right"
            class=" align-middle lh-40  f-15 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1">
            {{numberOfComments}}
          </span>
        </ng-container>
        <ng-container *ngIf="task.taskvisibility == 'vendor_only'">
          <span matTooltip="{{ 'projecttask.visibilityvendor' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500"
            class="material-icons align-middle lh-40  f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1 float-right">
            visibility_off
          </span>
        </ng-container>
        <ng-container *ngIf="task.taskstate != 'Done' && task.canEdit">
          <button (click)="taskDone(task); $any($event).stopPropagation();"
            class="taskboxhandler mt-1 btn btn-task border-0 bg-transparent p-0 float-right" data-toggle="modal"
            matTooltip="{{ 'projecttask.finishtask' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
            <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer">
              done
            </span>
          </button>
        </ng-container>
      </div>
    </div>

    <div *ngIf="customermyview && !customerourview" (click)="toggleCollapseArrow()" [ngClass]="{'done': task.taskstate == 'Done', 
    'open': task.taskstate != 'Done',
    'customer-task': isCustomerTask && !userview , 
    'vendor-task': !isCustomerTask && !userview,
    'my-task': myTask && !userview,
    'overdue-task': taskStatus == 'overdue' && userview,
    'due-task': taskStatus == 'midt' && userview,
    'upcoming-task': taskStatus == 'onTrack' && userview,
    'round-tops': task.show  }" class="row ml-0 mr-0 h-40">
      <div class="col-12 col-md-12 col-lg-5">
        <p class="lh-40 text-truncate mb-0 align-middle font-weight-bold cursor-pointer text-light">{{task.title}}</p>
      </div>
      <div class="col-5 d-none d-lg-block">
        <h6 class="h-40 text-truncate pt-0 text-light align-middle font-weight-light lh-40">{{ 'projecttask.duedate' |
          trans }}{{task.duedate}}</h6>
      </div>
      <div class="col col-md-2 col-lg-2">
        <ng-container>
          <span [ngClass]="{'visible': task.taskstate == 'Done', 'd-none': task.taskstate != 'Done'}"
            matTooltip="{{ 'projecttask.taskisdone' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"
            class="material-icons align-middle lh-40 f-18 rounded-circle transistion cursor-pointer opacity text-white cursor-pointer mr-1 ml-1 float-right">
            done
          </span>
        </ng-container>
        <ng-container *ngIf="numberOfFiles && numberOfFiles > 0">
          <span matTooltip="{{ 'projecttask.filesareattached' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500"
            class="material-icons align-middle lh-40 f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1 float-right">
            attach_file
          </span>
        </ng-container>
        <ng-container *ngIf="numberOfComments > 0"
          matTooltip="{{numberOfComments}}{{ 'projecttask.commentsrelated' | trans }}" matTooltipPosition="above"
          matTooltipShowDelay="500">
          <span (click)="setTaskFilter(task)"
            matTooltip="{{numberOfComments}}{{ 'projecttask.commentsrelated' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500" class=" h-40 rounded cursor-pointer transistion float-right"
            class=" align-middle lh-40  f-15 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1">
            {{numberOfComments}}
          </span>
        </ng-container>
        <ng-container *ngIf="task.taskvisibility == 'vendor_only'">
          <span matTooltip="{{ 'projecttask.visibilityvendor' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500"
            class="material-icons align-middle lh-40  f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1 float-right">
            visibility_off
          </span>
        </ng-container>
        <ng-container *ngIf="task.taskstate != 'Done' && task.canEdit">
          <button (click)="taskDone(task); $any($event).stopPropagation();"
            class="taskboxhandler mt-1 btn btn-task border-0 bg-transparent p-0 float-right" data-toggle="modal"
            matTooltip="{{ 'projecttask.finishtask' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
            <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer">
              done
            </span>
          </button>
        </ng-container>
      </div>
    </div>

    <div *ngIf="customerourview && !customermyview" (click)="toggleCollapseArrow()" [ngClass]="{'done': task.taskstate == 'Done', 
    'open': task.taskstate != 'Done',
    'customer-task': isCustomerTask && !userview , 
    'vendor-task': !isCustomerTask && !userview,
    'my-task': myTask && !userview,
    'overdue-task': taskStatus == 'overdue' && userview,
    'due-task': taskStatus == 'midt' && userview,
    'upcoming-task': taskStatus == 'onTrack' && userview,
    'round-tops': task.show  }" style="background-color: #CCC;" class="row flex-nowrap ml-0 mr-0 h-40">
      <div class="col-5">
        <p class="lh-40 text-truncate mb-0 align-middle font-weight-bold cursor-pointer text-light">{{task.title}}</p>
      </div>
      <div class="col-2 d-none d-lg-block">
        <h6 matTooltip="{{ 'projecttask.duedate' | trans }}{{task.duedate}}" matTooltipPosition="above"
          matTooltipShowDelay="500"
          class="h-40 pt-0 text-light align-middle mb-0 font-weight-light lh-40 text-truncate">{{task.duedate}}</h6>
      </div>
      <div class="col-3 d-none d-md-block">
        <h6 class="h-40 pt-0 text-light align-middle lh-40 mb-0 float-right"><app-personname [creatorstage]="''"
            [spacing]="false" [chatType]="false" [enableChange]="false"
            *ngIf="(task.responsible || '').substr(0,5) != 'role_'"
            [personId]="(task.responsible || '') | slice:0:36 "></app-personname></h6>
      </div>
      <div class="col col-md-2 col-lg-2">
        <ng-container>
          <span [ngClass]="{'visible': task.taskstate == 'Done', 'd-none': task.taskstate != 'Done'}"
            matTooltip="{{ 'projecttask.taskisdone' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"
            class="material-icons align-middle lh-40 f-18 rounded-circle transistion cursor-pointer opacity text-white cursor-pointer mr-1 ml-1 float-right">
            done
          </span>
        </ng-container>
        <ng-container *ngIf="numberOfFiles && numberOfFiles > 0">
          <span matTooltip="{{ 'projecttask.filesareattached' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500"
            class="material-icons align-middle lh-40 f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1 float-right">
            attach_file
          </span>
        </ng-container>
        <ng-container *ngIf="numberOfComments > 0"
          matTooltip="{{numberOfComments}}{{ 'projecttask.commentsrelated' | trans }}" matTooltipPosition="above"
          matTooltipShowDelay="500">
          <span (click)="setTaskFilter(task)"
            matTooltip="{{numberOfComments}}{{ 'projecttask.commentsrelated' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500" class=" h-40 rounded cursor-pointer transistion float-right"
            class=" align-middle lh-40  f-15 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1">
            {{numberOfComments}}
          </span>
        </ng-container>
        <ng-container *ngIf="task.taskvisibility == 'vendor_only'">
          <span matTooltip="{{ 'projecttask.visibilityvendor' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500"
            class="material-icons align-middle lh-40  f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1 float-right">
            visibility_off
          </span>
        </ng-container>
        <ng-container *ngIf="task.taskstate != 'Done' && task.canEdit">
          <button (click)="taskDone(task); $any($event).stopPropagation();"
            class="taskboxhandler mt-1 btn btn-task border-0 bg-transparent p-0 float-right" data-toggle="modal"
            matTooltip="{{ 'projecttask.finishtask' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
            <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer">
              done
            </span>
          </button>
        </ng-container>
      </div>
    </div>


    <div *ngIf="listviewsetting" (click)="toggleCollapseArrow()" [ngClass]="{'done': task.taskstate == 'Done', 
    'open': task.taskstate != 'Done',
    'customer-task': isCustomerTask && !userview , 
    'vendor-task': !isCustomerTask && !userview,
    'my-task': myTask && !userview,
    'overdue-task': taskStatus == 'overdue' && userview,
    'due-task': taskStatus == 'midt' && userview,
    'upcoming-task': taskStatus == 'onTrack' && userview,
    'round-tops': task.show  }" class="row ml-0 mr-0 h-40 ">
      <div class="col">
        <p class="lh-40 text-truncate d-inline mb-0 align-middle font-weight-bold cursor-pointer text-light">
          {{task.title}}</p>
      </div>
      <div class="col-3 d-none d-lg-block">
        <h6 class="h-40 pt-0 text-light align-middle text-truncate font-weight-light lh-40 ">{{ 'projecttask.duration' |
          trans }}{{task.startdate}} - {{task.duedate}}</h6>
      </div>
      <div class="col-3 d-none d-md-block">
        <h6 class="h-40 pt-0 text-light align-middle text-truncate lh-40 float-right">{{ 'projecttask.customer' | trans
          }}{{task.customername}}</h6>
      </div>
      <div class="col col-md-2 col-lg-2">
        <ng-container>
          <span [ngClass]="{'visible': task.taskstate == 'Done', 'd-none': task.taskstate != 'Done'}"
            matTooltip="{{ 'projecttask.taskisdone' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"
            class="material-icons align-middle lh-40 f-18 rounded-circle transistion cursor-pointer opacity text-white cursor-pointer mr-1 ml-1 float-right">
            done
          </span>
        </ng-container>
        <ng-container *ngIf="numberOfFiles && numberOfFiles > 0">
          <span matTooltip="{{ 'projecttask.attachtip' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"
            class="material-icons align-middle lh-40 f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1 float-right">
            attach_file
          </span>
        </ng-container>
        <ng-container *ngIf="numberOfComments > 0"
          matTooltip="{{numberOfComments}}{{ 'projecttask.commentsrelated' | trans }}" matTooltipPosition="above"
          matTooltipShowDelay="500">
          <span (click)="setTaskFilter(task)"
            matTooltip="{{numberOfComments}}{{ 'projecttask.commentsrelated' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500" class=" h-40 rounded cursor-pointer transistion float-right"
            class=" align-middle lh-40  f-15 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1">
            {{numberOfComments}}
          </span>
        </ng-container>
        <ng-container *ngIf="task.taskvisibility == 'vendor_only'">
          <span matTooltip="{{ 'projecttask.visibilityvendor' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500"
            class="material-icons align-middle lh-40  f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1 float-right">
            visibility_off
          </span>
        </ng-container>
        <ng-container *ngIf="task?.taskstate != 'Done' && task.canEdit">
          <button (click)="taskDone(task); $any($event).stopPropagation();"
            class="taskboxhandler mt-1 btn btn-task border-0 bg-transparent p-0 float-right" data-toggle="modal"
            matTooltip="{{ 'projecttask.finishtask' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
            <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer">
              done
            </span>
          </button>
        </ng-container>
      </div>
    </div>

    <div *ngIf="!listviewsetting && !userview && !customermyview && !customerourview" (click)="toggleCollapseArrow()"
      class="pl-3 pr-2 d-flex flex-nowrap flex-row h-40 justify-content-between" [ngClass]="{'done': task?.taskstate == 'Done', 
'open': task?.taskstate != 'Done',
'customer-task': isCustomerTask && !userview , 
'vendor-task': !isCustomerTask && !userview,
'my-task': myTask && !userview,
'overdue-task': taskStatus == 'overdue' && userview,
'due-task': taskStatus == 'midt' && userview,
'upcoming-task': taskStatus == 'onTrack' && userview,
'round-tops': task.show  }">

      <p class="lh-40 text-truncate d-inline mb-0 align-middle font-weight-bold cursor-pointer text-light">
        {{task.title}}</p>

      <div class="d-inline-flex flex-nowrap" [ngClass]="{'pr-6px': task.tasktype == 'event'}">
        <ng-container>
          <span [ngClass]="{'visible': task.taskstate == 'Done', 'd-none': task.taskstate != 'Done'}"
            matTooltip="{{ 'projecttask.taskisdone' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"
            class="material-icons align-middle lh-40  f-18 rounded-circle transistion cursor-pointer opacity text-white cursor-pointer mr-1 ml-1">
            done
          </span>
        </ng-container>
        <ng-container *ngIf="numberOfFiles && numberOfFiles > 0">
          <span matTooltip="{{ 'projecttask.attachtip' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"
            class="material-icons align-middle lh-40 f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1">
            attach_file
          </span>
        </ng-container>
        <ng-container *ngIf="numberOfComments > 0"
          matTooltip="{{numberOfComments}}{{ 'projecttask.commentsrelated' | trans }}" matTooltipPosition="above"
          matTooltipShowDelay="500">
          <span (click)="setTaskFilter(task)"
            matTooltip="{{numberOfComments}}{{ 'projecttask.commentsrelated' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500" class=" h-40 rounded cursor-pointer transistion"
            class=" align-middle lh-40  f-15 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1">
            {{numberOfComments}}
          </span>
        </ng-container>
        <ng-container *ngIf="task.taskvisibility == 'vendor_only'">
          <span matTooltip="{{ 'projecttask.visibilityvendor' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500"
            class="material-icons align-middle lh-40  f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1">
            visibility_off
          </span>
        </ng-container>
        <!----automation type indicator start
        <ng-container>
          <span matTooltip="{{ 'projecttask.projectautomations' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500" style="margin-top: -2px;"
            class="material-icons align-middle lh-40  f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1 ">
            settings_suggest
          </span>
        </ng-container>
        automation type indicator end--->

        <!----Form type indicator start--->
        <ng-container *ngIf="task.tasktype == 'form'">
          <span matTooltip="{{ 'projecttask.formtip' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"
            class="material-icons align-middle lh-40  f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1">
            app_registration
          </span>
        </ng-container>
        <!----Form type indicator end--->
        <!----Event type indicator start--->
        <ng-container *ngIf="task.tasktype == 'event'">
          <span matTooltip="{{ 'projecttask.visibilityvendor' | trans }}" matTooltipPosition="above"
            matTooltipShowDelay="500"
            class="material-icons align-middle lh-40  f-18 rounded-circle transistion cursor-pointer opacity text-white mr-1 ml-1">
            event
          </span>
        </ng-container>
        <!----Event type indicator end--->
        <ng-container *ngIf="task.taskstate != 'Done' && task.canEdit && task.tasktype != 'event'">
          <button (click)="taskDone(task); $any($event).stopPropagation();"
            class="taskboxhandler mt-1 btn btn-task border-0 bg-transparent p-0 float-right" data-toggle="modal"
            matTooltip="{{ 'projecttask.finishtask' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
            <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer">
              done
            </span>
          </button>
        </ng-container>
      </div>


      <!--ALMOST INDICATOR STRIPE-->
      <div *ngIf="taskStatus == 'midt' && !userview"
        class="almostindicator w-10 bg-almost h-10 ml-1 mr-1 rounded-circle position-absolute l-10 mt-15"
        [ngClass]="{'stripe-expanded': task.show}" matTooltip="{{ 'projecttask.taskduetoday' | trans }}"></div>
      <!--NOT ON TRACK INDICATOR STRIPE-->
      <div *ngIf="taskStatus == 'overdue' && !userview"
        class="notindicator w-10 h-10 bg-close rounded-circle position-absolute mt-15 ml-1 mr-1 l-10"
        [ngClass]="{'stripe-expanded': task.show}" matTooltip="{{ 'projecttask.taskdue' | trans }}{{task.duedate}}">
      </div>

    </div>
    <div [@inbgOutAnimation] *ngIf="task?.show" [ngClass]="{'done': task?.taskstate == 'Done', 
'open': task.taskstate != 'Done',
'customer-task': isCustomerTask && !userview , 
'vendor-task': !isCustomerTask && !userview,
'my-task': myTask && !userview,
'overdue-task': taskStatus == 'overdue' && userview,
'due-task': taskStatus == 'midt' && userview,
'upcoming-task': taskStatus == 'onTrack' && userview ,
'greytask': customerourview}" class="task-expand-box-w-counter mt-0">
      <p class="cursor-pointer text-light"><quill-view-html class="quill-no-pad text-light" [content]="task.description"
          theme="bubble"></quill-view-html></p>
      <ng-container *ngIf="task.tasktype != 'event'">
        <p class="cursor-pointer text-light">{{ 'projecttask.startdate' | trans }}{{task.startdate | date:
          'dd-MM-yyyy'}}
        </p>
        <p class="cursor-pointer text-light">{{ 'projecttask.duedate' | trans }}{{task.duedate | date: 'dd-MM-yyyy'}}
        </p>
      </ng-container>
      <!---event condition start---->
      <ng-container *ngIf="task.tasktype == 'event'">
        <p class="cursor-pointer text-light">{{ 'projecttask.eventstart' | trans }}{{ task.startdate | date: 'HH:mm
          dd-MM-yyyy' }}
        </p>
        <p class="cursor-pointer text-light">{{ 'projecttask.eventend' | trans }}{{ task.duedate | date: 'HH:mm
          dd-MM-yyyy' }}
        </p>
      </ng-container>

      <!---event condition end---->
      <!---- Time tracking counter (timereg org module) ---->
      <div *ngIf="timeregEnabled && timeCounterLabel() as counter" class="pr-1 mb-3">
        <span class="text-light f-12 cursor-default">
          <p class="text-light btn-text rounded"> {{ 'projecttask.hourslogged' | trans }} - {{ counter }}
          </p>
        </span>
      </div>

      <p class="cursor-pointer text-light">
        <app-personname [creatorstage]="''" [chatType]="false" [enableChange]="false"
          *ngIf="(task.responsible || '').substr(0,5) != 'role_'"
          [personId]="(task.responsible || '') | slice:0:36 "></app-personname>
        <span *ngIf="(task.responsible || '').substr(0,4) === 'role'">{{ task.responsible }}</span>
      </p>

      <!---Form template indicator start---->
      <ng-container *ngIf="task.tasktype === 'form' && task.formTemplateId">
        <div class="form-indicator mt-2 cursor-pointer" (click)="openFormModal(task); $any($event).stopPropagation()"
          matTooltip="Click to open form" matTooltipPosition="above" matTooltipShowDelay="500">
          <p class="f-14 text-light">
            <span class="material-icons align-middle text-light"
              style="font-size: 15px!important; margin-top: -2px;">description</span>
            {{ 'projecttask.linkedform' | trans }}: {{ task.formTemplateName || 'Form' }}
            <span *ngIf="task.formTemplateVersion" class="badge align-middle badge-secondary ml-1">
              v{{ task.formTemplateVersion }}
            </span>
          </p>
        </div>
      </ng-container>
      <!---Form template indicator end---->

      <div *ngIf="numberOfFiles && numberOfFiles > 0" class="row pb-2">
        <div class="col" style="padding-left:8px!important; margin-top: -2px;">
          <div class="row">
            <div class="col-auto">
              <button [disabled]="showFileListLoader" class="btn btn-task border-0 bg-transparent p-0"
                (click)="togglefilelist()">
                <p class="text-light btn-text rounded pr-2 pl-2" style="transition: ease-in-out 0.2s;" role="button"
                  data-toggle="collapse" [attr.href]="'#collapsefiles' + task.taskId">
                  <ng-container *ngIf="!filelist && !showFileListLoader">{{ 'projecttask.showfiles' | trans
                    }}</ng-container>
                  <ng-container *ngIf="filelist && !showFileListLoader">{{ 'projecttask.hidefiles' | trans
                    }}</ng-container>
                  <ng-container *ngIf="showFileListLoader">Loading files...</ng-container>
                </p>
              </button>
            </div>
            <div *ngIf="showFileListLoader" class="col pl-0" style="padding-top: 5px; transition: ease-in-out 0.2s;">
              <div class="loader-files"></div>
            </div>
          </div>
        </div>
      </div>


      <div class="row collapse pt-1" id="collapsefiles{{task.taskId}}">
        <div class="col" style="padding-left: 12px;">
          <app-filelist *ngIf="filelist" [projectId]="task.projectId" [list]="false" [fileToAdd]="fileToAdd"
            (numberOfFiles)="setNumberOfFiles($event); filelistLoaded();" [filetype]="'task'"
            [entityid]="task.taskId"></app-filelist>
        </div>
      </div>



      <div class="d-flex justify-content-between">
        <div *ngIf="task.canEdit && !showDelete">
          <button id="deletetaskbutton" [attr.data-target]="'#deletetaskModal' + task.taskId"
            *ngIf="task.canEdit && !showDelete" class="btn btn-task border-0 bg-transparent p-0" data-toggle="modal"
            matTooltip="{{ 'projecttask.deletetask' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
            <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer">
              delete
            </span>
          </button>
        </div>
        <div *ngIf="task.canEdit">
          <ng-container *ngIf="task.canEdit">
            <button id="edittaskbutton" (click)="clickEdit(task);" class="btn btn-task border-0 bg-transparent p-0"
              matTooltip="{{ 'projecttask.edittask' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
              <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer">
                create
              </span>
            </button>
          </ng-container>
        </div>
        <div>
          <button id="filebutton" data-toggle="modal" [attr.data-target]="'#myfileModal' +task.taskId"
            class="btn btn-task border-0 bg-transparent p-0" matTooltip="{{ 'projecttask.attachfiles' | trans }}"
            matTooltipPosition="above" matTooltipShowDelay="500">
            <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer">
              attach_file
            </span>
          </button>
        </div>
        <div>
          <button id="commentbutton" (click)="setTaskFilter(task); $any($event).stopPropagation()"
            class="btn btn-task border-0 bg-transparent p-0" matTooltip="{{ 'projecttask.commentontask' | trans }}"
            matTooltipPosition="above" matTooltipShowDelay="500">
            <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer ">
              quickreply
            </span>
          </button>
        </div>
        <div *ngIf="userview">
          <button *ngIf="userview" class="btn btn-task border-0 bg-transparent p-0"
            matTooltip="{{ 'projecttask.launchproject' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"
            (click)="navigate(task)">
            <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer">
              launch
            </span>
          </button>
        </div>
        <div *ngIf="task.canEdit && showDelete">
          <ng-container *ngIf="task.canEdit && showDelete">
            <button (click)="DeleteConfirm()" *ngIf="task.canEdit && showDelete"
              matTooltip="{{ 'projecttask.deletetask' | trans }}" class="btn btn-task border-0 bg-transparent p-0"
              matTooltipPosition="above" matTooltipShowDelay="500">
              <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer">
                cancel
              </span>
            </button>
          </ng-container>
        </div>

        <!---form specific task button--->
        <div *ngIf="task.tasktype == 'form'" class="">
          <ng-container *ngIf="task.canEdit && task.tasktype == 'form'">
            <button (click)="openFormModal(task);" id="finishtaskbutton"
              class="btn btn-task border-0 bg-transparent p-0" *ngIf="task.canEdit">
              <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer"
                matTooltip="{{ 'projecttask.formfill' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
                app_registration
              </span>
            </button>
          </ng-container>
        </div>

        <div *ngIf="task.tasktype != 'event'" class="">
          <ng-container
            *ngIf="task.taskstate != 'Done' && task.canEdit && task.tasktype != 'event' && task.tasktype != 'form'">
            <button id="finishtaskbutton" [ngClass]="{'task-handler': taskstatetrack && taskanimationtype == 'bounceIn',
                            'task-handler-bounce': taskstatetrack &&  taskanimationtype == 'bounce',
                            'task-handler-swing': taskstatetrack && taskanimationtype == 'swing',
                            'task-handler-wobble': taskstatetrack && taskanimationtype == 'wobble',
                            'task-handler-rubberband': taskstatetrack && taskanimationtype == 'rubberBand'}"
              (click)="taskDone(task); $any($event).stopPropagation();" class="btn btn-task border-0 bg-transparent p-0"
              *ngIf="task.taskstate != 'Done' && task.canEdit">
              <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer"
                matTooltip="{{ 'projecttask.marktaskasdone' | trans }}" matTooltipPosition="above"
                matTooltipShowDelay="500">
                assignment_turned_in
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="task.taskstate == 'Done' && task.canEdit && task.tasktype != 'event'">
            <button id="unfinishtaskbutton" [ngClass]="{'task-handler': taskanimationtype == 'bounceIn',
        'task-handler-bounce': taskstatetrack && taskanimationtype == 'bounce',
        'task-handler-swing': taskstatetrack && taskanimationtype == 'swing',
        'task-handler-wobble': taskstatetrack && taskanimationtype == 'wobble',
        'task-handler-rubberband': taskstatetrack && taskanimationtype == 'rubberBand'}"
              *ngIf="task.taskstate == 'Done' && task.canEdit"
              (click)="taskUndone(task); $any($event).stopPropagation()"
              matTooltip="{{ 'projecttask.formfill' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500"
              class="btn btn-task border-0 bg-transparent p-0">
              <span class="material-icons text-center rounded-circle mb-1 p-1 pl-0 pr-0 text-white cursor-pointer">
                assignment_return
              </span>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- INPUT TASK MESSAGE END-->
<div id="myfileModal{{task?.taskId}}" class="modal fade" tabindex="-1" role="dialog">
  <app-fileupload (fileUploaded)="newFile($event)" [filetype]="'task'" [index]="task?.taskId"
    [organizationId]="organizationId" [projectId]="task?.projectId" [customerId]="customerId"></app-fileupload>
</div>
<!-- Modal DELTETE TASK-->
<div class="modal fade" id="deletetaskModal{{task?.taskId}}" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'projecttask.deletetask' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <p>{{ 'projecttask.pleaseconfirm' | trans }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button data-dismiss="modal" id="canceltaskdelete" class="btn-close">
              <h6 class="btn-save-text">{{ 'projecttask.cancel' | trans }}</h6>
            </button>
          </div>
          <div class="col">
            <button (click)="deleteTask(task)" id="confirmtaskdelete" data-dismiss="modal"
              class="btn-save close-color-bg">
              <h6 class="btn-save-text">{{ 'projecttask.delete' | trans }}</h6>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-alertbox *ngIf="showtaskdeletealert" [@inbgOutAnimation] [alerticon]="'check_circle'" [alerttype]="'success'"
  [alerttext]="'projecttask.deletedalert' | trans"></app-alertbox>